import { z } from 'zod';
import { workspaceSchema } from './workshop.js';
export const supportLevelSchema = z.enum([
    'quiet',
    'standard',
    'high_support',
    'voice_first',
    'reflection',
    'hint_only',
]);
export const learnerProfileSchema = z.object({
    id: z.uuid(),
    email: z.email(),
    displayName: z.string().nullable(),
    avatarUrl: z.url().nullable(),
    supportLevel: supportLevelSchema,
    onboardingCompletedAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
});
export const updateLearnerProfileSchema = z
    .object({
    displayName: z.string().trim().min(1).max(80),
    supportLevel: supportLevelSchema,
})
    .partial();
export const learnerBootstrapSchema = z.object({
    learner: learnerProfileSchema,
    program: z.object({ id: z.uuid(), slug: z.string(), title: z.string() }),
    access: z.object({
        status: z.enum(['active', 'suspended', 'expired']),
        expiresAt: z.iso.datetime().nullable(),
    }),
    workspace: workspaceSchema,
});
